import React from 'react';
import { Badge } from 'react-bootstrap';

/**
 * A component that displays document type with appropriate color and formatting
 */
const DocumentTypeTag = ({ type }) => {
  // Format document type
  const formatDocumentType = (type) => {
    if (!type) return 'Other';

    // Handle specific document types
    if (type.toLowerCase() === 'proposal') {
      return 'Proposal';
    }
    
    if (type.toLowerCase() === 'payment_schedule') {
      return 'Payment Schedule';
    }
    
    // If it's already formatted properly, return as is
    if (/^[A-Z][a-z]+(\s[A-Z][a-z]+)*$/.test(type)) {
      return type;
    }
    
    // Format other types: convert to title case
    return type
      .replace(/_/g, ' ')
      .split(' ')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(' ');
  };

  // Get badge color based on document type
  const getBadgeColor = (type) => {
    if (!type) return 'secondary';
    
    const typeKey = type.toLowerCase();
    
    // Return specific colors based on document type
    switch (typeKey) {
      case 'proposal':
        return 'primary';
      case 'payment_schedule':
        return 'success';
      case 'invoice':
        return 'danger';
      case 'contract':
        return 'warning';
      case 'pdf':
        return 'danger';
      case 'docx':
        return 'primary';
      case 'xlsx':
        return 'success';
      case 'image':
      case 'jpg':
      case 'jpeg':
      case 'png':
        return 'info';
      default:
        return 'secondary';
    }
  };

  const formattedType = formatDocumentType(type);
  const badgeColor = getBadgeColor(type);

  return (
    <Badge 
      bg={badgeColor}
      className="ms-2"
      style={{ fontSize: '0.8rem', fontWeight: 500 }}
    >
      {formattedType}
    </Badge>
  );
};

export default DocumentTypeTag;
